import axios from 'axios';
import { logger } from '@parrot-software/observability';

import type { IHubspotPort } from '@onboarding/application/ports';
import type { HubspotPropertiesDto } from '@onboarding/application/dtos';
import { getHubspotProperties } from '@onboarding/domain/value-objects';

const onbLog = logger.forDomain('ONB');

/**
 * Use case for sending HubSpot properties when the restaurant type is selected.
 *
 * Flow: HubspotPropertiesDto → domain mapping → port.
 *
 * @param props.hubspotPort - IHubspotPort implementation (injected)
 * @returns Use case executor
 */
export const updateHubspotPropertiesUseCase = (props: { hubspotPort: IHubspotPort }) => {
  const { hubspotPort } = props;

  const execute = async (dto: HubspotPropertiesDto): Promise<void> => {
    const { storeProfile, serviceType } = getHubspotProperties(dto.restaurantType);
    try {
      await hubspotPort.updateHubspotProperties(storeProfile, serviceType);
    } catch (error) {
      onbLog.warn('hubspot_sync_failed', {
        'error.kind': (error as { constructor?: { name?: string } })?.constructor?.name ?? 'UnknownError',
        'error.message': error instanceof Error ? error.message : String(error),
        'http.status_code': axios.isAxiosError(error) ? error.response?.status : undefined,
      });
      throw error;
    }
  };

  return { execute };
};
